import { IActivityHistoryItem } from "../model";
import { Spec } from "./spec";

export class UpFilterSpec extends Spec<IActivityHistoryItem> {
  constructor(private upIds: string[]) {
    super();
  }

  isSatisfiedBy(item: IActivityHistoryItem): boolean {
    if (!this.upIds?.length) {
      return true; // No se filtra si no se proporcionan códigos
    }

    const itemUp = item.up ?? null;

    return this.upIds.some((upId) => itemUp.id === upId);
  }
}
